import { useState, useRef } from 'react';

interface ImagePlaceholderProps {
  src: string;
  alt: string;
  className?: string;
  loading?: 'lazy' | 'eager';
  fetchpriority?: 'high' | 'low' | 'auto';
  width?: number;
  height?: number;
}

export default function ImagePlaceholder({
  src,
  alt,
  className = '',
  loading = 'lazy',
  fetchpriority = 'auto',
  width,
  height,
}: ImagePlaceholderProps) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  return (
    <div className={`relative overflow-hidden bg-[#E8EFF5] ${className}`}>
      {!error && (
        <img
          ref={imgRef}
          src={src}
          alt={alt}
          loading={loading}
          decoding="async"
          fetchPriority={fetchpriority}
          width={width}
          height={height}
          onLoad={() => setLoaded(true)}
          onError={() => setError(true)}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
            loaded ? 'opacity-100' : 'opacity-0'
          }`}
        />
      )}
      {/* Skeleton pendant le chargement */}
      {!loaded && !error && (
        <div className="absolute inset-0 bg-[#E8EFF5] animate-pulse" />
      )}
      {error && (
        <div className="absolute inset-0 bg-[#F4F8FB] flex flex-col items-center justify-center text-[#143A66]/30">
          <i className="ri-image-line text-3xl mb-1" style={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}></i>
          <span className="text-xs font-medium">Photo</span>
        </div>
      )}
    </div>
  );
}